export const TYPE_COLORS = {
  "Cardio base":   { bg: "#E0F2FE", text: "#0369A1", dot: "#0EA5E9" },
  "Fuerza":        { bg: "#FEF3C7", text: "#92400E", dot: "#F59E0B" },
  "Carrera":       { bg: "#D1FAE5", text: "#065F46", dot: "#10B981" },
  "Descanso":      { bg: "#F3F4F6", text: "#6B7280", dot: "#9CA3AF" },
  "Carrera larga": { bg: "#EDE9FE", text: "#5B21B6", dot: "#8B5CF6" },
  "Meta":          { bg: "#FFE4E6", text: "#9F1239", dot: "#F43F5E" },
};

export const WEEK_LABELS = [
  "SEMANA 1 — Base",
  "SEMANA 2 — Construcción",
  "SEMANA 3 — Afinamiento",
];

export const WEEK_RANGES = [
  { start: 0, end: 4 },
  { start: 4, end: 11 },
  { start: 11, end: 17 },
];

export const EXERCISE_LABELS = {
  sentadilla:        "Sentadilla",
  zancada:           "Zancada",
  plancha:           "Plancha",
  elevacion_talones: "Elevación de talones",
  running:           "Técnica de carrera",
  stretching:        "Estiramientos",
};

export const EXERCISE_EMOJIS = {
  running:           "🏃",
  stretching:        "🧘",
  sentadilla:        "🦵",
  zancada:           "🚶",
  plancha:           "💪",
  elevacion_talones: "🦶",
};

export const RACE_DATE = new Date(2026, 4, 31);
